import { useEffect } from 'react';
import { connect } from 'react-redux';
// Redux
import {getChannels}    from '../../redux/actions/Channels';

// Components
import Head         from '../global/Head';
import Tables       from './Tables';
import Form         from './Form';
// Values
import {StateView}  from '../../values';
// Api
import {getData} from '../../utils/channels';

const Index = ({stateView, token, getChannels}) => {
    const GetData = async() =>{
        const res1 = await getData(token)
        getChannels(res1.data)
    }
    useEffect(() =>{
        if(token){
            if(stateView === StateView.state1){
                GetData()
            }
        }
    })
    return (
        <div>
            <Head title='Mensajero' />
            {
                stateView===StateView.state1?
                    <Tables />
                :
                    <Form />
            }
        </div>
    );
};

const mapStateToProps = state =>({
    stateView:      state.View.stateView,
    token:          state.Panel.token
})

export default connect(mapStateToProps, {getChannels})(Index);
